import { useContext } from 'react';
import { currentPromoLimitContext } from './context';

export const useCurrentPromoLimit = () => {
  const limit = useContext(currentPromoLimitContext);
  return limit;
};
